<template>
  <div>
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="green">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="dialog.attachment"
      @keydown.esc="dialog.attachment = false"
      :fullscreen="dialog.fullscreen"
      width="1000"
      persistent
      scrollable>
      <v-card v-if="Object.keys(selected.item).length > 0"
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title 
          class="d-flex align-center py-0 px-3 text-right popup-header">
          Lampiran

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.attachment = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>
        
        <v-card-text
          class="px-4">
          <div v-if="selected.item.attachment.split('.').pop() !== 'pdf'">
            <v-img
              contain
              alt="amanata" 
              width="100%"
              height="auto"
              :src="selected.item.attachment"
              class="ma-auto border-radius">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    :color="set_color">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </div>

          <div v-else>
            <iframe 
              :src="`${selected.item.attachment}#toolbar=0`" 
              allowfullscreen
              frameborder="0" 
              width="100%"
              height="750"
              style="border-radius: 15px; border: 2px solid #323639;">
            </iframe>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.add_nilai"
      @keydown.esc="dialog.add_nilai = false"
      :fullscreen="dialog.fullscreen"
      width="600"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <div
          class="title font-weight-bold black--text text-center mt-4 mb-2">
          Keterlibatan Sebagai Pengurus Peserta Diluar Unit Bisnis
        </div>

        <div
          class="body-2 text-center mb-4">
          Tentukan nilai berdasarkan informasi dibawah ini:
        </div>

        <v-divider class="mx-4 mb-3 mt-0"/>
        
        <v-card-text
          class="pb-1 mt-2">
          <ValidationObserver 
            ref="form">
            <v-form>
              <div
                class="body-2 mb-6">
                <ul
                  style="position: relative; left: -10px;">
                  <li
                    v-for="(item, index) in info"
                    :key="index"
                    :class="index < info.length - 1 ? 'mb-2' : ''"
                    v-html="item">  
                  </li>
                </ul>
              </div>

              <ValidationProvider 
                name="label_score" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <!-- <span class="red--text">*</span> -->
                  Kehadiran
                  <!-- <span class="error--text">
                    (wajib diisi)
                  </span> -->
                </div>

                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  hide-details
                  type="number"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  min="0"

                  placeholder="Contoh. 4"

                  v-model="form.label_score"
                  :success="form.label_score !== '' && valid"
                  :error-messages="errors"
                  class="mb-6"
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Kehadiran {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.label_score !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider 
                name="score" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <!-- <span class="red--text">*</span> -->
                  Skor
                  <!-- <span class="error--text">
                    (wajib diisi)
                  </span> -->
                </div>

                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  hide-details
                  type="number"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  min="0"

                  readonly

                  placeholder="Contoh. 80"

                  v-model="form.score"
                  :success="form.score !== '' && valid"
                  :error-messages="errors"
                  class="mb-6"
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Skor {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.score !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-form>
          </ValidationObserver>
        </v-card-text>

        <v-alert v-if="message.error.length > 0"
          class="mx-6"
          type="error" 
          dense
          text 
          prominent>
          {{ message.error }}
        </v-alert>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            @click="save_nilai()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.add_nilai = false; dialog.fullscreen = false; reset();">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.reset"
      @keydown.esc="dialog.reset = false"
      :fullscreen="dialog.fullscreen"
      width="500"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Reset Nilai

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.reset = false; dialog.fullscreen = false; selected.reset = {};"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text class="body-1 font-weight-light text-first mt-3">
          Apakah Anda yakin mereset nilai data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
        </v-card-text>

        <v-alert v-if="message.error.length > 0"
          class="mx-6"
          type="error" 
          dense
          text 
          prominent>
          {{ message.error }}
        </v-alert>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.reset"
            :loading="process.reset"
            @click="resetes()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Ya, Reset
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.reset"
            @click="dialog.reset = false; dialog.fullscreen = false; selected.reset = {};">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col 
        cols="12"
        class="pt-0">
        <v-card
          flat
          :color="set_color_rgb_soft"
          style="border-radius: 10px;">
          <v-card-text>
            <v-row>
              <v-col
                cols="12"
                md="10"
                class="py-0">
                <div
                  class="d-flex align-center">
                  <v-avatar 
                    size="40" 
                    tile>
                    <v-img 
                      alt="amanata" 
                      :src="detail.image_url === '' ? require('@/assets/image/member_default.jpg') : detail.image_url"
                      class="ma-auto"
                      style="border-radius: 10px;">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            color="white">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <div
                    class="font-weight-bold ml-4"
                    :style="`color: ${set_color};`">
                    {{ detail.code }}
                  </div>

                  <v-divider
                    vertical
                    class="my-2 mx-4"
                    style="border: 1px solid #e0e0e0; border-radius: 50px;" />

                  <div
                    class="font-weight-bold"
                    :style="`color: ${set_color};`">
                    {{ detail.name }}
                  </div>

                  <v-divider
                    vertical
                    class="my-2 mx-4"
                    style="border: 1px solid #e0e0e0; border-radius: 50px;" />

                  <div
                    class="font-weight-bold"
                    :style="`color: ${set_color};`">
                    {{ detail.position }}
                  </div>
                </div>
              </v-col>

              <v-col
                cols="12"
                md="2"
                class="py-0">
                <!-- <v-menu
                  ref="picker"
                  min-width="290px"
                  max-width="290px"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  :close-on-content-click="false"
                  v-model="picker">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      readonly
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Pilih Tanggal"
                      prepend-inner-icon="mdi-calendar-range"

                      hide-details

                      clearable
                      @click:clear="filter.date = ''; fetchData(); fetchSkor();"

                      v-on="on"
                      v-bind="attrs"

                      v-model="filter.date"
                      class="no_box_white"
                      style="border-radius: 10px;">
                    </v-text-field>
                  </template>

                  <v-date-picker 
                    type="month"
                    :color="set_color"
                    v-model="filter.date"
                    @input="picker = false; fetchData(); fetchSkor();">
                  </v-date-picker>
                </v-menu> -->

                <v-select
                  filled
                  rounded
                  dense

                  :color="set_color"
                  placeholder="Pilih Tahun"
                  prepend-inner-icon="mdi-calendar-range"

                  hide-details

                  :items="years"

                  clearable
                  @click:clear="filter.year = ''; fetchData(); fetchSkor();"

                  @change="fetchData(); fetchSkor();"

                  v-model="filter.year"
                  class="no_box_white">
                </v-select>
              </v-col>

              <!-- <v-col
                cols="12"
                md="2"
                class="py-0">
                <v-btn
                  block
                  height="40"
                  color="white"
                  elevation="0"
                  class="text-capitalize d-flex align-center"
                  style="border-radius: 8px;">
                  <v-icon style="opacity: 60%;">mdi-alert-decagram-outline</v-icon>
                  
                  <span
                    class="ml-1"
                    style="opacity: 60%;">
                    Komplain
                  </span>
                </v-btn>
              </v-col> -->
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col 
        cols="12"
        class="pb-0">
        <v-card 
          flat 
          style="border: 1px solid #E0E0E0;">
          <v-card-text>
            <v-skeleton-loader
              v-for="(item, index) in process.load ? 5 : list"
              :key="index"
              :loading="process.load"
              class="mb-4"
              type="article">
              <v-expansion-panels
                flat>
                <v-expansion-panel
                  style="background: #f0f0f0;">
                  <v-expansion-panel-header>
                    <div>
                      <div
                        class="font-weight-bold mb-4"
                        :style="`color: ${set_color};`">
                        {{ item.title }}
                      </div>

                      <div
                        class="d-flex align-center">
                        <div
                          class="d-flex align-center mr-8"
                          style="opacity: 70%;">
                          <v-icon small>mdi-calendar-range</v-icon>
                          
                          <span
                            class="caption ml-1">
                            {{ item.datetime | date }}
                          </span>
                        </div>

                        <div
                          class="d-flex align-center"
                          style="opacity: 70%;">
                          <v-icon small>mdi-clock-time-four-outline</v-icon>
                          
                          <span
                            class="caption ml-1">
                            {{ item.datetime | time }} WIB
                          </span>
                        </div>
                      </div>
                    </div>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content>
                    <div
                      class="my-2"
                      :style="`color: ${set_color}; font-weight: 500;`">
                      Deskripsi Pekerjaan
                    </div>

                    <v-card
                      flat
                      class="mb-4"
                      style="border-radius: 10px;">
                      <v-card-text
                        class="line-text-second"
                        style="padding-top: 12px;">
                        {{ item.desc }}
                      </v-card-text>
                    </v-card>

                    <v-card
                      flat
                      style="border-radius: 10px;">
                      <v-card-text
                        class="line-text-second d-flex align-start"
                        style="padding-top: 12px;">
                        <v-icon>mdi-attachment</v-icon>

                        <span v-if="item.attachment !== ''"
                          @click="dialog.attachment = true; selected.item = item;"
                          class="blue--text cursor-pointer ml-2">
                          {{ item.attachment }}
                        </span>

                        <span v-else
                          class="ml-2">
                          Tidak ada lampiran
                        </span>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-skeleton-loader>

            <pagination v-if="pagination.total_data > 0"
              @changePage="fetchData($event)" 
              @reloadPage="fetchData($event)" 
              :model="pagination"/>

            <v-row>
              <v-col
                cols="11"
                class="pr-0">
                <v-card
                  @click="dialog.add_nilai = true; reset();"
                  flat
                  :color="set_color_rgb_soft"
                  style="border: 1px solid #e0e0e0; border-right: 0px; border-radius: 4px 0px 0px 4px;">
                  <v-card-text
                    class="font-weight-bold"
                    :style="`color: ${set_color};`">
                    Jumlah Kehadiran{{ detail_skor.indicator_score === '' ? ', klik disini' : ` adalah` }}

                    <span v-if="detail_skor.indicator_score !== ''">
                      {{ detail_skor.indicator_label_score }}
                    </span>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col
                cols="1"
                class="pl-0">
                <v-card
                  flat
                  min-height="56"
                  style="border: 1px solid #e0e0e0; border-radius: 0px 4px 4px 0px;">
                  <v-card-text
                    class="font-weight-bold text-center">
                    {{ detail_skor.indicator_score }}
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-alert v-if="message.error.length > 0"
              class="mx-6"
              type="error" 
              dense
              text 
              prominent>
              {{ message.error }}
            </v-alert>
          </v-card-text>

          <v-card-actions
            class="ma-2 mt-0 mb-3">
            <v-spacer/>

            <v-btn
              @click="$router.go(-1)"
              outlined
              style="border-radius: 10px;"
              class="body-2 font-weight-bold text-capitalize red--text">
              <v-icon color="red" small class="mr-1">mdi-arrow-left-thick</v-icon>
              Kembali
            </v-btn>

            <v-btn v-if="detail_skor.indicator_id !== ''"
              @click="toReset()"
              color="orange"
              elevation="0"
              style="border-radius: 10px;"
              class="body-2 font-weight-bold text-capitalize white--text">
              <v-icon small class="mr-1">mdi-reload</v-icon>

              Reset Nilai
            </v-btn>

            <v-btn
              @click="$router.go(-1)"
              color="green"
              elevation="0"
              style="border-radius: 10px;"
              class="body-2 font-weight-bold text-capitalize white--text">
              <v-icon small class="mr-1">mdi-check-bold</v-icon>
              Simpan Penilaian
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        dialog: {
          snackbar: false,
          fullscreen: false,
          attachment: false,

          add_nilai: false,
          reset: false
        },

        search: '',

        filter: {
          unit: '',
          date: moment().format('YYYY-MM'),

          year: parseInt(moment().format('YYYY'))
        },

        selected: {
          item: {},
          reset: {}
        },

        info: [
          'Kehadiran 0 (Skor 0)',
          'Kehadiran 1 (Skor 20)',
          'Kehadiran 2 (Skor 40)',
          'Kehadiran 3 (Skor 60)',
          'Kehadiran 4 (Skor 80)',
          'Kehadiran 5 (Skor 100)'
        ],

        picker: false,

        detail: {},
        detail_skor: {},

        unit: [],

        options: {},
        headers: [],

        list: [],
        pagination: {},

        limit: 20,

        form: {
          id: '',
          user_id: '',
          label_score: '',
          score: '',

          indicator_id: ''
        },

        process: {
          load: false,

          form: false,
          reset: false,

          detail: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.1)`
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },

      years () {
        let max = new Date().getFullYear(), min = max - 10, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      }
    },
    watch: {
      'filter.date': function(val) {
        this.filter.date_focus = moment(`${val}-01`).format('YYYY-MM-DD')
      },

      'form.label_score': function(val) {
        if (val === '') {
          this.form.score = ''
        } else {
          if (val == 0 ) {
            this.form.score = 0
          }
  
          if (val == 1) {
            this.form.score = 20
          }

          if (val == 2) {
            this.form.score = 40
          }
  
          if (val == 3) {
            this.form.score = 60
          }
  
          if (val == 4) {
            this.form.score = 80
          }
  
          if (val == 5) {
            this.form.score = 100
          }
        }
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      fetch () {
        this.fetchDetail()
        this.fetchData()
        this.fetchSkor()
      },

      async fetchDetail () {
        this.process.detail = true

        let params = {
          id: this.$route.params.id
        }

        await get('admin/user/detail', { params })
        .then(response => {
          let res = response.data

          this.process.detail = false
            
          if (res.status === 200) {
            this.detail = res.results.data
          }
        })
      },

      async fetchData (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row

        let params = {
          limit: pagination.row,
          page: pagination.page,

          user_id: this.$route.params.id,
          unit_id: this.filter.unit,

          // year: this.filter.date !== '' && this.filter.date !== null ? this.filter.date.split('-')[0] : '',
          // month: this.filter.date !== '' && this.filter.date !== null ? this.filter.date.split('-')[1] : ''

          year: this.filter.year

          // user_indicator_id: 8
        }

        await get('kpi/peserta_aum/detail', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            this.list = res.results.data
            this.pagination = res.results.pagination
          }
        })
      },

      async fetchSkor () {
        let params = {
          user_id: this.$route.params.id,
          unit_id: this.filter.unit,
          
          // year: this.filter.date !== '' && this.filter.date !== null ? this.filter.date.split('-')[0] : '',
          // month: this.filter.date !== '' && this.filter.date !== null ? this.filter.date.split('-')[1] : '',

          year: this.filter.year

          // indicator_id: 8
        }

        await get('kpi/peserta_aum/data', { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.detail_skor = res.results.data.length > 0 ? res.results.data[0] : {
              indicator_label_score: 0,
              indicator_score: 0
            }
          }
        })
      },

      reset () {
        if (this.$refs.form) this.$refs.form.reset()

        let params = {
          user_id: this.$route.params.id,
          unit_id: this.filter.unit,

          // year: this.filter.date !== '' && this.filter.date !== null ? this.filter.date.split('-')[0] : '',
          // month: this.filter.date !== '' && this.filter.date !== null ? this.filter.date.split('-')[1] : '',

          year: this.filter.year,

          // user_indicator_id: 8
        }

        get('kpi/peserta_aum/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.form = {
              id: this.detail_skor.indicator_id,
              user_id: this.detail.id,
              label_score: this.detail_skor.indicator_label_score !== '' ? parseInt(this.detail_skor.indicator_label_score) : parseInt(res.results.label),
              score: this.detail_skor.indicator_score !== '' ? this.detail_skor.indicator_score : res.results.score,

              // indicator_id: 8
            }
          }
        })
        
        // this.form = {
        //   id: this.detail_skor.indicator_id,
        //   user_id: this.detail.id,
        //   label_score: this.detail_skor.indicator_label_score,
        //   score: this.detail_skor.indicator_score,

        //   // indicator_id: 8
        // }

        this.process.form = false

        this.message.error = ''
      },

      async save_nilai () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = this.detail_skor.indicator_label_score === '' ? 'kpi/peserta_aum/add_score' : 'kpi/peserta_aum/update_score'

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.add_nilai = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.fetchSkor()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      toReset () {
        this.selected.reset = this.detail_skor

        this.dialog.reset = true
      },
      async resetes () {
        this.message.error = ''

        this.process.reset = true

        await post('kpi/peserta_aum/reset_score', {
          data: {
            id: this.selected.reset.indicator_id
          }
        }).then(response => {
          let res = response.data

          if (res.status === 200) {
            this.process.reset = false
            this.dialog.reset = false

            this.selected.reset = {}
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetchSkor()
          } else {
            this.process.reset = false
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>